function buildMenu (allowed) {
  let menu = [
    {
      title: 'Help',
      icon: 'mdi-help-circle-outline',
      items: [
        // {
        //   title: 'Videos', 
        //   icon: 'mdi-video-outline',
        //   path: '/HelpVideos'
        // },
        {
          title: 'Tutorials', 
          icon: 'mdi-teach',
          path: '/HelpTutorials'
        },
        // {
        //   title: 'Cortex Products', 
        //   icon: 'mdi-table-large',
        //   path: '/HelpProducts'
        // },
        // {
        //   title: 'Cortex Sensors', 
        //   icon: 'mdi-gauge',
        //   path: '/HelpSensors'
        // },
      ]
    }
  ] 
  return menu
}

export default buildMenu